import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ILogResult } from '../models/log-result.interface';

@Injectable({
  providedIn: 'root',
})
export class ScrapeLogsService {
    private apiUrl: string = environment.apiUrl;

    constructor(private http: HttpClient) {}
  
    /**
     * 
     * @param website website
     * @returns 0-1, 0 being the least reliable and 1 being the most reliable. -1 if the website is not found.
     */
    getWebsiteReliability(website: string, title: string): Observable<number> {
      const url = `${this.apiUrl}/scrape-logs/`;
      const params = new HttpParams({ fromObject: { website, title } });
      return this.http.get<number>(url, { params });
    }
}
